import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import ForgotPasswordForm from './ForgotPasswordForm';
import Header from '../../shared/Header';

import { forgotPassword } from './redux/actions';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: #2a425e;
  display: flex;
  justify-content: center;
`;

class ForgotPassword extends Component {
  render() {
    return (
      <Wrapper>
        <Header type="login" />
        <ForgotPasswordForm forgotPassword={this.props.forgotPassword} />
      </Wrapper>
    );
  }
}

export default connect(
  null,
  { forgotPassword }
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/screens/ForgotPassword/ForgotPassword.jsx